// src/components/InvoiceItemsTable.jsx
import React, { useCallback } from 'react';
import axios from "axios";
import AsyncSelect from "react-select/async";
import toast from 'react-hot-toast';
const API_URL = process.env.REACT_APP_API_URL;
// 1. Accept the new 'taxApplicable' prop
const InvoiceItemsTable = ({ lineItems, setLineItems, headers, taxApplicable,customerCode }) => {
  const loadProductOptions = (inputValue, callback) => {
    if (!inputValue) return callback([]);
    axios
      .get(`${API_URL}/products/search?query=${encodeURIComponent(inputValue)}`, { headers })
      .then(res => {
        const options = (res.data?.items || []).map(p => ({
          ...p,
          label: p.prodname,
          value: p.prodcode,
        }));
        callback(options);
      })
      .catch(() => callback([]));
  };

  const sanitizeDecimal = (v) => {
    if (typeof v !== 'string') v = String(v ?? '');
    return v.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
  };

// src/components/InvoiceItemsTable.jsx
const handleRateFocus = (index) => {
    const updated = [...lineItems];
    updated[index].showSuggestions = true;
    setLineItems(updated);
};

const handleRateBlur = (index) => {
    setTimeout(() => {
        // This is the key change. We pass a function to setLineItems.
        // `currentItems` is guaranteed to be the most up-to-date state.
        setLineItems(currentItems => {
            const updated = [...currentItems];
            if (updated[index]) {
                updated[index].showSuggestions = false;
            }
            return updated; // Return the new, correct state
        });
    }, 200);
};

    const handleLineItemChange = useCallback(
        async (index, field, value) => { // Make async
          if (field === 'prodcode' && value) {
        if (!customerCode) {
          toast.error('Please select a customer before adding a product.');
          return; // Stop the function from proceeding
        }
      }
          const updated = [...lineItems];
          let currentItem = { ...updated[index] };
        if (field === 'rate') {
          currentItem.showSuggestions = false;
        }
          if (field === 'prodcode') {
            // Reset the line item
            currentItem = {
                prodcode: "", prodname: "", qty: "", rate: "", taxper: 0, uom: "", 
                hsncode: "", totalvalue: 0, originalTax: 0, 
                suggestions: [], showSuggestions: false 
            };
            if (value) {
              const originalTaxRate = value.taxpercent || 0;
              currentItem.prodcode = value.prodcode;
              currentItem.prodname = value.prodname;
              currentItem.uom = value.uom;
              currentItem.hsncode = value.hsncode;
              currentItem.originalTax = originalTaxRate;
              currentItem.taxper = taxApplicable ? originalTaxRate : 0;

              // Fetch suggestions
              if (customerCode && value.prodcode) {
                  try {
                      const res = await axios.get(
                          `${API_URL}/reports/product-history-for-customer?prodcode=${value.prodcode}&customercode=${customerCode}`,
                          { headers }
                      );
                    if (res.data && res.data.type !== 'none' && res.data.data) {
                                          currentItem.suggestions = [res.data];
                                      } else {
                                          currentItem.suggestions = [];
                                      }
                                    }catch (error) {
                      console.error("Failed to fetch price history:", error);
                      currentItem.suggestions = [];
                  }
              }
            }
          } else {
            currentItem[field] = value;
          }

          const qty = parseFloat(currentItem.qty) || 0;
          const rate = parseFloat(currentItem.rate) || 0;
          currentItem.totalvalue = qty * rate;

          updated[index] = currentItem;
          setLineItems(updated);
        },
        [lineItems, setLineItems, taxApplicable, customerCode, headers]
    );

  const handleAddLine = () => {
    setLineItems([
      ...lineItems,
      // 3. Ensure new lines have the 'originalTax' field for consistency
      { prodcode: "", prodname: "", qty: "", rate: "", taxper: 0, uom: "", hsncode: "", totalvalue: 0, originalTax: 0,suggestions: [], showSuggestions: false },
    ]);
  };

  const handleRemoveLine = (index) => {
    setLineItems(lineItems.filter((_, i) => i !== index));
  };

  const selectStyles = {
    control: (provided) => ({ ...provided, minHeight: '40px' }),
    menu: (provided) => ({ ...provided, zIndex: 10 }),
  };
    const formatFinYearForDisplay = (finyear) => {
    if (typeof finyear === 'string' && finyear.includes('-')) {
        const parts = finyear.split('-');
        if (parts.length === 2) {
            // Takes the last two digits of the start and end year
            return `${parts[0].slice(-2)}-${parts[1].slice(-2)}`;
        }
    }
    return finyear; // Fallback if the format is unexpected
  };

  return (
    <div className="items-table-container">
      <table className="items-table">
        <thead>
          <tr>
            <th className="th-sno">S.No.</th>
            <th className="th-product">Product</th>
            <th className="th-qty">Qty</th>
            <th className="th-rate">Rate</th>
            <th className="th-tax">Tax %</th>
            <th className="th-uom">UOM</th>
            <th className="th-hsn">HSN</th>
            <th className="th-total">Total</th>
            <th className="th-action"></th>
          </tr>
        </thead>
        <tbody>
  {lineItems.map((item, idx) => (
    <tr key={idx}>
      <td data-label="S.No.">{idx + 1}</td>
      <td data-label="Product"> {/* Add data-label */}
        <AsyncSelect
          styles={selectStyles}
          cacheOptions
          defaultOptions
          loadOptions={loadProductOptions}
          value={item.prodcode ? { value: item.prodcode, label: item.prodname } : null}
          onChange={(opt) => handleLineItemChange(idx, 'prodcode', opt)}
          placeholder="Type to search..."
        />
      </td>
      <td data-label="Qty"> {/* Add data-label */}
        <input
          type="number"
          inputMode="decimal"
          value={item.qty}
          onChange={(e) => handleLineItemChange(idx, 'qty', e.target.value)}
          onWheel={(e) => e.currentTarget.blur()}
          required
        />
      </td>
      <td data-label="Rate" className="rate-cell"> {/* Add a class for styling */}
        <input
          type="text"
          inputMode="decimal"
          value={item.rate}
          onChange={(e) => handleLineItemChange(idx, 'rate', e.target.value)}
          onFocus={() => handleRateFocus(idx)}
          onBlur={() => handleRateBlur(idx)}
          onWheel={(e) => e.currentTarget.blur()}
          required
        />
        {item.showSuggestions && item.suggestions.length > 0 && (
          <div className="rate-suggestions-dropdown">
            {item.suggestions.map((suggestion, sIdx) => (
              <div 
                key={sIdx} 
                className="suggestion-item"
                onMouseDown={() => handleLineItemChange(idx, 'rate', suggestion.data.rate)}
              >
                {suggestion.type === 'customer_specific' ? (
                  <>
                    Last: <strong>₹{Number(suggestion.data.rate).toFixed(2)}</strong>
                    <span>(Inv #{suggestion.data.docno}/{formatFinYearForDisplay(suggestion.data.finyear)})</span>
                  </>
                ) : (
                  <>
                    FYI: <strong>₹{Number(suggestion.data.rate).toFixed(2)}</strong>
              <span>(To {suggestion.data.customerName.split(' ')[0]} / Inv #{suggestion.data.docno}/{formatFinYearForDisplay(suggestion.data.finyear)})</span>                  </>
                )}
              </div>
            ))}
          </div>
        )}
      </td>
      <td data-label="Tax %"> {/* Add data-label */}
        <input
          type="text"
          inputMode="decimal"
          value={item.taxper}
          readOnly
          disabled={!taxApplicable}
        />
      </td>
      <td data-label="UOM"> {/* Add data-label */}
        <input type="text" className="uom-input" value={item.uom || ''} readOnly disabled />
      </td>
      <td data-label="HSN"> {/* Add data-label */}
        <input type="text" value={item.hsncode || ""} readOnly disabled />
      </td>
      <td data-label="Total"> {/* Add data-label */}
        <input type="text" value={(item.totalvalue || 0).toFixed(2)} readOnly disabled />
      </td>
      <td> {/* No label needed for the remove button cell */}
        <button className="remove-btn" onClick={() => handleRemoveLine(idx)}>
          &times;
        </button>
      </td>
    </tr>
  ))}
</tbody>
      </table>

      <button onClick={handleAddLine} className="add-line-btn">+ Add Item</button>
    </div>
  );
};

export default InvoiceItemsTable;